import React from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { handleShowOn } from '../../services/functions';

export const InfoField = props => {
  const { info, formikValues, getFieldCallback, infoDynamicText } = props;
  const color = info.color === 'gray' ? 'primary' : info.color ? info.color : 'primary';

  return (
    <Typography variant="subtitle" color={color} style={{ paddingBottom: 7, paddingTop: 7, display: handleShowOn(
      info.show_on, formikValues,
      getFieldCallback(!_.isNil(info.show_on) ? info.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}>
      {!_.isEmpty(info.fa_icon) && !_.isNil(info.fa_icon) && info.fa_icon !== 'null'
        ? <FontAwesomeIcon
          icon={['fas', info.fa_icon]}
          color={color} />
        : null}
      <div style={{ display: 'inline', marginLeft: 3 }} dangerouslySetInnerHTML={{ __html: `${info.label} ${infoDynamicText ? infoDynamicText : ''}` }}></div>
    </Typography>
  );
};
